import { render, staticRenderFns } from "./FinishAccountSetup.vue?vue&type=template&id=b49c37e0"
import script from "./FinishAccountSetup.vue?vue&type=script&lang=js"
export * from "./FinishAccountSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports